import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import 'react-multi-carousel/lib/styles.css';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../helpers/font-awesome';
import { getDateFormatted } from '../../helpers/getDateFormatted';
import './DiariesCards.scss';

function DiariesCards({ diary }) {
  // Formato de la Fecha
  const objDate = getDateFormatted(diary.date);
 
  // Creando el objeto con la Fecha y Hora del evento
  const setDate = diary.date + " " + diary.time;

  return (
    <div
      key={`diariesId-${diary.id}`}
      className={`mx-2 p-4 h-100 rounded shadow diaries-cards-container ${
        (new Date(setDate) < new Date()) ? 'disabled' : 'bg-white'
      }`}
    >
      <Link to={`/agenda/${diary.slug}`} className="text-decoration-none diaries-cards-link">
        <div className="text-center text-uppercase d-flex flex-column align-items-center justify-content-center py-2 border-bottom date-container">
          <div className="day-style">
            {objDate.day}
          </div>
          <div className="number-style">
            {objDate.numberDay}
          </div>
          <div className="day-style">
            {objDate.month}
          </div>
        </div>
        <div className="text-uppercase h-50 d-flex flex-column align-items-center justify-content-center pt-2">
          <ReactMarkdown
            renderers= {{link: ({node, ...props}) => <a {...props} target="_blank" rel="noopener noreferrer"/>}}
            children={diary.title}
            className="diary-title"
          />
        </div>
        <div className="agenda-location">
          <FontAwesomeIcon
            icon={['fas', 'map-marker-alt']}
            size="lg"
            className="me-1 ucc-text-blue"
          />
          <span className="text-capitalize">
            {diary.place}
          </span>
        </div>
      </Link>
    </div>
  );
}

export default DiariesCards;

DiariesCards.propTypes = {
  diary: PropTypes.object.isRequired,
};